import { CanvasRendererFactory } from './canvasrender';
import { View, Canvas, Frame } from './view';
import { PageTypeEnum } from '@fullstory/client-api';
import { CanvasDecoder, CanvasDecoderCallback } from './canvasdecoder';
import { CanvasTokenDef } from './canvastokendef';

export abstract class MobileDriver<OP> {
  abstract type: PageTypeEnum;

  // This is a stop-gap until all the sessions we're recording have canvas definitions
  abstract defaultCanvasDefintion: Int8Array;

  abstract isBlockedFlag: number;
  abstract isWebViewFlag: number;

  abstract rendererFactory(): CanvasRendererFactory<OP>;

  abstract reprocessCanvas(view: View);

  abstract unpackCanvasItem(frame: Frame, canvasJson: any): Canvas<OP>;

  unpackCanvas(frame: Frame, decoder: CanvasDecoder): Canvas<OP>[] {
    let lastCanvas: any = {};
    const canvasJson = [];

    const callback: CanvasDecoderCallback = {
      op: (op: number) => {
        lastCanvas = {};
        lastCanvas.op = <any>op;
        canvasJson.push(lastCanvas);
      },
      value: (token: CanvasTokenDef, value) => {
        lastCanvas[token.keyName] = value;
      },
    };

    while (decoder.read(callback)) {
      // read loop
    }

    return canvasJson.map(x => this.unpackCanvasItem(frame, x));
  }
}
